// extracted by mini-css-extract-plugin
export var svgContainer = "e_bC_dx";
export var tablet = "e_bC_d8";